export const navItems = [
  {
    category: "Medición de Muestras",
    items: [
      { title: "Durómetro", seo_name: "durometro", id: 1 },
      { title: "Durómetro cápsulas blandas", seo_name: "durometro-capsulas-blandas", id: 1 },
      { title: "Desintegrador", seo_name: "desintegrador", id: 3 },
      { title: "Disolutor", seo_name: "disolutor", id: 5 },
      { title: "Penetrómetro", seo_name: "penetrometro", id: 7 },
      { title: "Friabilómetro", seo_name: "friabilometro", id: 12 },
      { title: "Texturómetro", seo_name: "texturometro", id: 4 },
      { title: "Medidor de Densidad", seo_name: "medidor-de-densidad", id: 13 },

    ],
  },
  {
    category: "Control de Ensayos",
    items: [
      { title: "Baño Termostático", seo_name: "bano-termostatico", id: 2 },
      { title: "Caudalímetro de Gases", seo_name: "caudalimetro-de-gases", id: 16 },
      { title: "Dosificadora de Polvos", seo_name: "dosificadora-de-polvos", id: 8 },
      { title: "Automuestreador", seo_name: "automuestreador", id: 6 },
    ],
  },
  {
    category: "Análisis de Calidad",
    items: [
      { title: "Titulador Automático", seo_name: "titulador-automatico", id: 15 },
      { title: "Test de Hermeticidad", seo_name: "test-de-hermeticidad", id: 14 },
    ],
  },
];
